module.exports = __webpack_public_path__ + "img/dashboard_reports.f7b56af0.svg";